// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import {
  eChannelsPermission,
} from '../../helpers/permissions'

const { axiosIns } = useJwt

export default {
  getHostFIList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/HostFI/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createHostFIAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_HOST_FINANCIAL_INSTITUTION)
      const response = await axiosIns.post(
        '/card/api/HostFI/v1/Add',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateHostFIAction: async (context, formData) => {
    try {
    //   useJwt.setPermission(accountPermissions.VIEW_ACCOUNT_OFFICER)
      useJwt.setPermission(eChannelsPermission.MODIFY_HOST_FINANCIAL_INSTITUTION)
      const response = await axiosIns.put(
        '/card/api/HostFI/v1/Update',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardProfile/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCardProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_CARD_PROFILE)
      const response = await axiosIns.post(
        '/card/api/CardProfile/v1/Add',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCardProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.MODIFY_CARD_PROFILE)
      const response = await axiosIns.put(
        '/card/api/CardProfile/v1/Update',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  updateStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/card/api/${routeName}/v1/UpdateStatus`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  requestUnAssignedCardsAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.REQUEST_UNASSIGNED_CARDS)
      const response = await axiosIns.post(
        '/card/api/CardGeneration/v1/RequestUnassignedCards',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  requestAssignedCardsAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.REQUEST_ASSIGNED_CARDS)
      const response = await axiosIns.post(
        '/card/api/CardGeneration/v1/RequestAssignedCards',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAssignedCardsByAccountNumbers: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/card/api/CardGeneration/v1/ValidateAssignedCardAccounts', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getListBatchRequests: async (context, { requestType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/card/api/CardGeneration/v1/GetBatchesForIssuance?RequestType=${requestType}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBatchRequestList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardGeneration/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  searchCustomerAccountToIssue: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardAccount/v1/GetDetailsOfAccountToIssue',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAvailableCardLists: async (context, { cardGenerationRequestId, issuanceStatus, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/card/api/Card/v1/Search?CardGenerationRequestId=${cardGenerationRequestId}&IssuanceStatus=${issuanceStatus}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createUnAssignedCardsAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(
        '/card/api/CardAccount/v1/LinkAccount',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAssignedCardsAction: async (context, { assignedFormData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(
        '/card/api/CardAccount/v1/IssueCard',
        assignedFormData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  withdrawCardAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(
        '/card/api/Card/v1/UnlinkCard', formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardAccountList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardAccount/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardRequestLogs: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/CardGeneration/v1/SearchCustomerCardRequest',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getManageCardList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/card/api/Card/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCardStatus: async (context, { statusValues, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/card/api/Card/v1/UpdateStatus', statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  takeCardDeliveryAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.RECEIVE_CARD_DELIVERY)
      const response = await axiosIns.put(
        '/card/api/CardGeneration/v1/TakeStockDelivery',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  revokeCardAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.REVOKE_CARD_REQUEST)
      const response = await axiosIns.put(
        '/card/api/CardGeneration/v1/Cancel',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  // Channel-Interbank Transfer
  getGatewayConfigurations: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/SearchTransferSettlementGl',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGatewayProviders: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/interbankpayment/api/Client/v1/GetConfiguredGateway',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInterBankTransferStatus: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/interbankpayment/api/Client/v1/',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createGatewayConfigurationAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_GL)
      const response = await axiosIns.post(
        '/interbankpayment/api/Client/v1/AddTransferSettlementGl',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateGatewayConfigurationAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_GL)
      const response = await axiosIns.put(
        '/interbankpayment/api/Client/v1/UpdateTransferSettlementGl',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // FEE CONFIGURATION SETUP
  getFeeConfigurations: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/Client/v1/SearchTransferFeeConfig',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createFeeConfiguration: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_FEE)
      const response = await axiosIns.post(
        '/interbankpayment/api/Client/v1/AddTransferFeeConfig',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFeeConfiguration: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_FEE)
      const response = await axiosIns.put(
        '/interbankpayment/api/Client/v1/UpdateTransferFeeConfig',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFeeConfigurationsByGateway: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CONFIGURE_TRANSFER_FEE)
      const response = await axiosIns.get(
        `/interbankpayment/api/Client/v1/SearchTransferFeeConfig?Gateway=${formData}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBankNameByAccountNumber: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/interbankpayment/api/OutwardTransferMiddleware/v1/NameEnquiry?DestinationAccountNumber=${formData.accountNumber}&SourceAccountNumber=${formData.sourceAccountNumber}&SourceAccountName=${formData.sourceAccountName}&ChannelCode=${formData.channelCode}&DestinationInstitutionCode=${formData.destinationInstitutionCode}&ClientRef=${formData.clientRef}&Amount=${formData.amount}`,
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  postOutwardTransferAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.INITIATE_TRANSFER)
      const response = await axiosIns.post(
        '/interbankpayment/api/OutwardTransferMiddleware/v1/OutwardTransfer',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFeeRangeAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.INITIATE_TRANSFER)
      const response = await axiosIns.get(
        `/interbankpayment/api/Client/v1/GetAmountFee?amount=${formData.amount}`,
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOutwardTransfer: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/OutwardTransferMiddleware/v1/SearchOutwardTransfer',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInwardTransfers: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/interbankpayment/api/OutwardTransferMiddleware/v1/SearchInwardTransfer',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performPendingRequestAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(
        `/interbankpayment/api/OutwardTransferMiddleware/v1/PostPendingInwardRequest?ids=${formData.ids}&isSessionIDPassed=${formData.isSessionIDPassed}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performRequeryStatus: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.INITIATE_TRANSFER)
      const response = await axiosIns.get(
        `/interbankpayment/api/OutwardTransferMiddleware/v1/TSQ?transactionReference=${formData.transactionReference}`,
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performRetryTransfer: async (context, id) => {
    try {
      useJwt.setPermission(eChannelsPermission.RETRY_TRANSFER)
      const response = await axiosIns.post(
        '/interbankpayment/api/OutwardTransferMiddleware/v1/RetryFailedTransfer', id,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAllBankList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/interbankpayment/api/OutwardTransferMiddleware/v1/GetBanks',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCurrentIntitutionGateway: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.SWITCH_TRANSFER_GATEWAY)
      const response = await axiosIns.get(
        '/interbankpayment/api/Client/v1/GetCurrentGateway',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateIntitutionGateway: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(
        '/interbankpayment/api/Client/v1/Update',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getCustomerProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/CustomerProfile/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCustomerProfileAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/CustomerProfile/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountsByCustomerId: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.VIEW_INTERNET_BANKING_USERS)
      const response = await axiosIns.get(
        `/accounting/api/CustomerAccount/v1/GetAccountsByCustomerID?customerId=${formData.customerId}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCustomerProfileStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/ibanking/api/Admin/v1/CustomerProfile/${routeName}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  generateTransactionReceipt: async (context, { transactionID, responseType }) => {
    try {
      useJwt.setPermission('VIEW_TRANSFER_REPORT')
      const response = await axiosIns.get(`/interbankpayment/api/OutwardTransferMiddleware/v1/ExportTransactionDetailToPDF?transactionID=${transactionID}`, { responseType })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFDProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/FixedDepositConfig/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProductProfileList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/CustomerOnboardingConfig/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createProductProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.post(
        '/ibanking/api/Admin/v1/CustomerOnboardingConfig/Create',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateProductProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.UPDATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.put(
        '/ibanking/api/Admin/v1/CustomerOnboardingConfig/Update',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateProductProfileStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/ibanking/api/Admin/v1/CustomerOnboardingConfig/${routeName}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createFixedDepositProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.CREATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.post(
        '/ibanking/api/Admin/v1/FixedDepositConfig/Add',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFixedDepositProfileAction: async (context, formData) => {
    try {
      useJwt.setPermission(eChannelsPermission.UPDATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG)
      const response = await axiosIns.put(
        '/ibanking/api/Admin/v1/FixedDepositConfig/Update',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFixedDepositProfileStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/ibanking/api/Admin/v1/FixedDepositConfig/${routeName}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getThemeConfigurationSetup: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get('/ibanking/api/Admin/v1/Theme/GetByRequestingBankCode')
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createThemeConfigurationSetupAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/Theme/Create', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateThemeConfigurationSetupAction: async (context, { formDataUpdate, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/Theme/Update', formDataUpdate)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  uploadImageFileAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Operations/v1/UploadFileV2', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountUpgradeRequest: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/ibanking/api/Admin/v1/GetAccountUpgradeRequests',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountUpgradeById: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/ibanking/api/Admin/v1/GetAccountUpgradeRequestById?id=${id}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  approveAccountUpgrade: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/ApproveAccountUpgradeRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateBVNAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/ValidateBVN', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateNINAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/ValidateNIN', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  validateTINAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/ibanking/api/Admin/v1/ValidateTIN', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFraudChecksList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/ibanking/api/Admin/v1/InstitutionConfig/GetByRequestingBankCode',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateFraudCheckAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/ibanking/api/Admin/v1/InstitutionConfig/AddOrUpdate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadBatchCard: async (context, { url, responseType }) => {
    try {
      const response = await axiosIns.get(url, { responseType })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillTypeList: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/bills/api/BillsManagement/v1/GetAllBillers',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillsCustomerNameAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/bills/api/BillsManagement/v1/GetCustomerInformation?CustomerId=${formData.customerId}&GlobalBillerIdentifier=${formData.globalBillerIdentifier}&ProductName=${formData.productName}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  performBillsPayment: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/bills/api/BillsManagement/v1/ProcessCustomerVendRequest', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  fetchBillsPaymentHistory: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/bills/api/BillsManagement/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  billsPaymentConfiguration: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/bills/api/BillsManagement/v1/CreateOrUpdateConfiguration', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillPaymentConfiguration: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/bills/api/BillsManagement/v1/GetConfiguration',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBillsWalletBalance: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/bills/api/BillsManagement/v1/GetBalance',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountLimitDetails: async (context, { accountNumber, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/limits/api/CustomerAccountLimit/v1/GetAccountLimit?accountNumber=${accountNumber}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getInstitutionLimitDetails: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/limits/api/InstitutionLimit/v1/GetByBankCode',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createAccountLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/limits/api/CustomerAccountLimit/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateAccountLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/limits/api/CustomerAccountLimit/v1/AddOrUpdate', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCardLimitDetails: async (context, { cardId, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/limits/api/CustomerCardLimit/v1/GetByCardId?cardId=${cardId}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createCardLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/limits/api/CustomerCardLimit/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateCardLimit: async (context, { formDataUpdate, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/limits/api/CustomerCardLimit/v1/Update', formDataUpdate)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createInstitutionLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/limits/api/InstitutionLimit/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateInstitutionLimit: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/limits/api/InstitutionLimit/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getWebhookNotifications: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/comms/api/WebhookNotification/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  resendWebhookAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/comms/api/WebhookNotification/v1/Resend', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getRegulatoryLimitsList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/limits/api/RegulatoryLimit/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOpenAPIList: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/admin/api/APIClient/v1/Search',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNotificationPreference: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/admin/api/APIClient/v1/GetNotificationTypes',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createOpenAPIAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/admin/api/APIClient/v1/Add', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOpenAPIAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/admin/api/APIClient/v1/Update', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateRegenerateClientSecret: async (context, { statusValues, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put('/admin/api/APIClient/v1/RegenerateSecret', statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOpenAPIStatus: async (context, { statusValues, routeName, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(`/admin/api/${routeName}/v1/UpdateStatus`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

}
